export const menuItems = [
    {
        label: 'Inicio',
        path: '#',
        icon: '',
    },
    {
        label: 'Encuéntranos',
        path: '#encuentranos',
        icon: '',
    },
    {
        label: 'Menú',
        path: '#menu',
        icon: '',
    },
    {
        label: 'Contáctanos',
        path: '#contactanos',
        icon: '',
    }
]
